/** Bottom-left caption block: author handle, title and description. */
export function Caption({ video }) {
  const author = video.author || video.title;
  return (
    <div class="caption">
      {author && <div class="caption__author">@{author}</div>}
      {video.title && video.title !== author && (
        <div class="caption__title">{video.title}</div>
      )}
      {video.caption && <div class="caption__text">{video.caption}</div>}
    </div>
  );
}
